import ApplicationMetadata from 'components/ApplicationMetadata/ApplicationMetadata';
import { PeachCollectorLoaded } from 'frontend/lib/peach';
import 'frontend/polyfills';
import { ThemeProvider } from 'next-themes';
import Script from 'next/script';
import { FC } from 'react';
import '../components/Player/jwStyles/skin.css';
import '../styles/globals.css';
interface FunctionalComponentWithTheme extends FC {
  theme?: string;
}
type Props = {
  Component: FunctionalComponentWithTheme;
  pageProps: React.Attributes;
};
function Application({
  Component,
  pageProps
}: Props) {
  return <>
      <ApplicationMetadata data-sentry-element="ApplicationMetadata" data-sentry-source-file="_app.tsx" />
      <ThemeProvider forcedTheme={Component.theme} themes={['child']} enableSystem={false} data-sentry-element="ThemeProvider" data-sentry-source-file="_app.tsx">
        <Component {...pageProps} data-sentry-element="Component" data-sentry-source-file="_app.tsx" />
      </ThemeProvider>
      <Script src="/peach/peach-collector-1.4.1.min.js" onLoad={() => {
      PeachCollectorLoaded();
    }} data-sentry-element="Script" data-sentry-source-file="_app.tsx" />
    </>;
}
export default Application;